import {Component} from '@angular/core';
import {TooltipConfig} from 'ngx-bootstrap/tooltip';
import {RoutesService} from './Core/Routes/routes.service';

export function getAlertConfig(): TooltipConfig {
  return Object.assign(new TooltipConfig(), {
    placement: 'bottom',
    container: 'body',
  });
}

@Component({
  selector: 'body',
  template: '<router-outlet></router-outlet>',
  providers: [RoutesService, {provide: TooltipConfig, useFactory: getAlertConfig}],
})
export class AppComponent {
  constructor() {}
}
